import styled from 'styled-components'

import { IconStatsClose } from 'assets/svg/sprite'

interface CloseButtonProps {
    onClick: () => void
    opacity?: number
}

const CloseButton = ({ onClick, opacity = 1 }: CloseButtonProps) => {
    return (
        <Container onClick={onClick} $opacity={opacity}>
            <IconStatsClose />
        </Container>
    )
}

const Container = styled.div<{ $opacity: number }>`
    cursor: pointer;
    opacity: ${({ $opacity }) => $opacity};

    & svg {
        width: 1.6rem;
        height: 1.6rem;
    }
`

export default CloseButton